module.exports = "/static-assets/_next/static/images/img-a58fded83c-841d13d8989bc588991a3f1b43fcae24.webp";